<template>
  <div>
    <div class="page-head"><div><h1>学员管理</h1><p>小程序填写姓名后自动建档 · 每 10 秒同步新学员</p></div><el-button type="primary" icon="el-icon-plus" @click="visible=true">新增学员</el-button></div>
    <div class="panel">
      <el-radio-group v-model="deleted" size="small" @change="load" style="margin-bottom:20px"><el-radio-button :label="false">在读学员</el-radio-button><el-radio-button :label="true">已删除</el-radio-button></el-radio-group>
      <el-alert v-if="deleted" title="删除只停用档案，姓名、手机号、余额与历史记录均保留。恢复后学员需重新登录。" type="info" :closable="false" style="margin-bottom:18px" />
      <div class="toolbar"><el-input v-model="query" placeholder="输入中文姓名或手机号" clearable style="width:250px" @keyup.enter.native="load" /><el-button @click="load">搜索</el-button><el-button icon="el-icon-refresh" @click="load">刷新</el-button></div>
      <el-table :data="rows" v-loading="loading" style="width:100%">
        <el-table-column prop="name" label="学员姓名" min-width="140"><template slot-scope="{row}"><div>{{ row.name }}</div><div style="font-size:11px;color:#939b96" :title="row.registered_at ? '微信登记时间' : '门店建立的学员档案'">{{ row.registered_at || '门店建档' }}</div></template></el-table-column>
        <el-table-column prop="phone" label="手机号" width="130"><template slot-scope="{row}">{{ row.phone || '未登记' }}</template></el-table-column>
        <el-table-column prop="level" label="级别" width="85" />
        <el-table-column label="剩余时长" width="100"><template slot-scope="{row}">{{ hours(row.balance) }} 小时</template></el-table-column>
        <el-table-column label="已预约" width="100"><template slot-scope="{row}">{{ hours(row.reserved_minutes) }} 小时</template></el-table-column>
        <el-table-column label="可预约" width="100"><template slot-scope="{row}">{{ hours(row.available) }} 小时</template></el-table-column>
        <el-table-column label="微信绑定" width="90"><template slot-scope="{row}"><el-tag size="mini" :type="row.wx_bound?'success':'info'">{{ row.wx_bound ? '已绑定' : '未绑定' }}</el-tag></template></el-table-column>
        <el-table-column label="操作" width="245" fixed="right"><template slot-scope="{row}"><template v-if="!deleted"><el-button size="mini" plain @click="openLevel(row)">设置级别</el-button><el-button size="mini" type="primary" plain @click="openCredit(row)">充值</el-button><el-button size="mini" type="danger" plain :disabled="saving" @click="remove(row)">删除</el-button></template><el-button v-else size="mini" type="primary" plain :disabled="saving" @click="restore(row)">恢复学员</el-button></template></el-table-column>
      </el-table>
    </div>
    <el-dialog title="新增学员" :visible.sync="visible" width="460px">
      <el-form :model="form" label-width="85px">
        <el-form-item label="姓名"><el-input v-model.trim="form.name" /></el-form-item>
        <el-form-item label="手机号"><el-input v-model.trim="form.phone" placeholder="填写学员授权登录时使用的手机号" /></el-form-item>
        <el-form-item label="级别"><el-select v-model="form.level"><el-option v-for="x in ['零基础','基础班','进阶班']" :key="x" :label="x" :value="x" /></el-select></el-form-item>
        <el-form-item label="初始时长"><el-input-number v-model="form.hours" :min="0" :max="1000" :step="0.5" /> 小时</el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="visible=false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>
    <el-dialog :title="'为 ' + (creditTarget ? creditTarget.name : '') + ' 充值'" :visible.sync="creditVisible" width="420px">
      <p v-if="creditTarget">当前剩余 {{ hours(creditTarget.balance) }} 小时</p>
      <el-input-number v-model="amount" :min="0.5" :max="1000" :step="0.5" /> 小时
      <span slot="footer"><el-button @click="creditVisible=false">取消</el-button><el-button type="primary" :loading="saving" @click="saveCredit">确认充值</el-button></span>
    </el-dialog>
    <el-dialog :title="'设置 ' + (levelTarget ? levelTarget.name : '') + ' 的级别'" :visible.sync="levelVisible" width="420px">
      <el-select v-model="levelValue" style="width:100%"><el-option v-for="x in ['零基础','基础班','进阶班']" :key="x" :label="x" :value="x" /></el-select>
      <span slot="footer"><el-button @click="levelVisible=false">取消</el-button><el-button type="primary" :loading="saving" @click="saveLevel">保存</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
import { listMembers, createMember, recharge, updateMemberLevel, deleteMember, restoreMember } from '../api'
const blank = () => ({ name: '', phone: '', level: '零基础', hours: 0 })
export default {
  data: () => ({ rows: [], deleted: false, query: '', appliedQuery: '', loading: false, saving: false, visible: false, form: blank(), creditVisible: false, creditTarget: null, amount: 15, levelVisible: false, levelTarget: null, levelValue: '零基础' }),
  created () { this.load() },
  mounted () {
    this.refreshTimer = setInterval(this.refresh, 10000)
    window.addEventListener('focus', this.refresh)
  },
  beforeDestroy () {
    clearInterval(this.refreshTimer)
    window.removeEventListener('focus', this.refresh)
    this.requestVersion = (this.requestVersion || 0) + 1
  },
  methods: {
    load () { this.appliedQuery = this.query.trim(); return this.fetchMembers(false) },
    refresh () { if (!document.hidden && !this.loading && !this.visible && !this.creditVisible) this.fetchMembers(true) },
    async fetchMembers (silent) {
      const version = this.requestVersion = (this.requestVersion || 0) + 1
      if (!silent) this.loading = true
      try {
        const rows = await listMembers(this.appliedQuery, this.deleted)
        if (version === this.requestVersion) this.rows = rows
      } catch (e) { if (!silent) this.$message.error(e.message) }
      finally { if (version === this.requestVersion) this.loading = false }
    },
    async save () {
      if (!/^1\d{10}$/.test(this.form.phone)) return this.$message.warning('请填写11位手机号，用于自动关联微信')
      if (!this.form.name) return this.$message.warning('请输入学员姓名')
      this.saving = true
      try { await createMember({ ...this.form, credits: Math.round(this.form.hours * 60) }); this.visible = false; this.form = blank(); this.$message.success('学员已添加'); this.load() }
      catch (e) { this.$message.error(e.message) } finally { this.saving = false }
    },
    openCredit (row) { this.creditTarget = row; this.amount = 15; this.creditVisible = true },
    openLevel (row) { this.levelTarget = row; this.levelValue = row.level || '零基础'; this.levelVisible = true },
    async saveLevel () {
      this.saving = true
      try { await updateMemberLevel(this.levelTarget.id, this.levelValue); this.levelVisible = false; this.$message.success('学员级别已更新'); this.load() }
      catch (e) { this.$message.error(e.message) } finally { this.saving = false }
    },
    async saveCredit () {
      this.saving = true
      try { await recharge(this.creditTarget.id, Math.round(this.amount * 60)); this.creditVisible = false; this.$message.success('充值成功'); this.load() }
      catch (e) { this.$message.error(e.message) } finally { this.saving = false }
    },
    async remove (row) {
      if (row.reserved_minutes > 0) return this.$message.warning('该学员还有待签到预约，请先在预约与签到中处理')
      try {
        await this.$confirm(`删除“${row.name}”后将停用登录，并移入已删除列表。剩余 ${this.hours(row.balance)} 小时及全部历史记录会保留，可随时恢复。`, '确认删除学员', { type: 'warning', confirmButtonText: '确认删除', cancelButtonText: '保留学员' })
      } catch (_) { return }
      this.saving = true
      try { await deleteMember(row.id); this.$message.success('已删除，可在已删除列表恢复'); await this.load() }
      catch (e) { this.$message.error(e.message) } finally { this.saving = false }
    },
    async restore (row) {
      this.saving = true
      try { await restoreMember(row.id); this.$message.success('学员已恢复，请重新登录小程序'); await this.load() }
      catch (e) { this.$message.error(e.message) } finally { this.saving = false }
    },
    hours (minutes) { return Number((Number(minutes || 0) / 60).toFixed(2)) }

  }
}
</script>
